// This file is auto-generated. Do not edit directly.

export const typeSystemMap = {
  "mssql": {
    "image": {
      "minimum": "",
      "maximum": "",
      "maxLength": "2147483647",
      "pattern": "",
      "jsonType": "string",
      "component": "",
      "inputType": "",
      "step": "",
      "validationMessage": "",
      "notes": "The ntext, text, and image data types will be removed in a future version of SQL Server"
    },
    "text": {
      "minimum": "",
      "maximum": "",
      "maxLength": "{{ 2147483647 }}",
      "pattern": "",
      "jsonType": "string",
      "component": "b-input",
      "inputType": "textarea",
      "step": "",
      "validationMessage": "",
      "notes": "The ntext, text, and image data types will be removed in a future version of SQL Server"
    },
    "uniqueidentifier": {
      "minimum": "",
      "maximum": "",
      "maxLength": "{{ 36 }}",
      "pattern": "^[{]?[0-9a-fA-F]{8}-([0-9a-fA-F]{4}-){3}[0-9a-fA-F]{12}[}]?$",
      "jsonType": "string",
      "component": "b-input",
      "inputType": "text",
      "step": "",
      "validationMessage": "Must be of form: xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx",
      "notes": ""
    },
    "date": {
      "minimum": "0000-01-01T00:00:00Z",
      "maximum": "9999-12-31T00:00:00Z",
      "maxLength": "",
      "pattern": "",
      "jsonType": "string",
      "component": "b-datepicker",
      "inputType": "",
      "step": "",
      "validationMessage": "",
      "notes": ""
    },
    "time": {
      "minimum": "",
      "maximum": "",
      "maxLength": "",
      "pattern": "",
      "jsonType": "string",
      "component": "b-timepicker",
      "inputType": "",
      "step": "",
      "validationMessage": "",
      "notes": ""
    },
    "datetime2": {
      "minimum": "0000-01-01T00:00:00Z",
      "maximum": "9999-12-31T00:00:00Z",
      "maxLength": "",
      "pattern": "",
      "jsonType": "string",
      "component": "b-datetimepicker",
      "inputType": "",
      "step": "",
      "validationMessage": "",
      "notes": "datetime2 can be considered as an extension of the existing datetime type that has a larger date range, a larger default fractional precision, and optional user-specified precision."
    },
    "datetimeoffset": {
      "minimum": "0000-01-01T00:00:00Z",
      "maximum": "9999-12-31T00:00:00Z",
      "maxLength": "",
      "pattern": "",
      "jsonType": "string",
      "component": "b-datetimepicker",
      "inputType": "",
      "step": "",
      "validationMessage": "",
      "notes": ""
    },
    "tinyint": {
      "minimum": "0",
      "maximum": "255",
      "maxLength": "",
      "pattern": "",
      "jsonType": "number",
      "component": "b-input",
      "inputType": "number",
      "step": "1",
      "validationMessage": "",
      "notes": ""
    },
    "smallint": {
      "minimum": "-32768",
      "maximum": "32767",
      "maxLength": "",
      "pattern": "",
      "jsonType": "number",
      "component": "b-input",
      "inputType": "number",
      "step": "1",
      "validationMessage": "",
      "notes": ""
    },
    "int": {
      "minimum": "-2147483648",
      "maximum": "2147483647",
      "maxLength": "",
      "pattern": "",
      "jsonType": "number",
      "component": "b-input",
      "inputType": "number",
      "step": "1",
      "validationMessage": "",
      "notes": ""
    },
    "smalldatetime": {
      "minimum": "1900-01-01T00:00:00Z",
      "maximum": "2079-06-06T00:00:00Z",
      "maxLength": "",
      "pattern": "",
      "jsonType": "string",
      "component": "b-datetimepicker",
      "inputType": "",
      "step": "",
      "validationMessage": "",
      "notes": ""
    },
    "real": {
      "minimum": "",
      "maximum": "",
      "maxLength": "",
      "pattern": "",
      "jsonType": "number",
      "component": "b-input",
      "inputType": "number",
      "step": "any",
      "validationMessage": "",
      "notes": ""
    },
    "money": {
      "minimum": "-922337203685477.5808",
      "maximum": "922337203685477.5808",
      "maxLength": "",
      "pattern": "",
      "jsonType": "number",
      "component": "b-input",
      "inputType": "number",
      "step": "0.0001",
      "validationMessage": "",
      "notes": ""
    },
    "datetime": {
      "minimum": "1753-01-01T00:00:00Z",
      "maximum": "9999-12-31T00:00:00Z",
      "maxLength": "",
      "pattern": "",
      "jsonType": "string",
      "component": "b-datetimepicker",
      "inputType": "",
      "step": "",
      "validationMessage": "",
      "notes": ""
    },
    "float": {
      "minimum": "",
      "maximum": "",
      "maxLength": "",
      "pattern": "",
      "jsonType": "number",
      "component": "b-input",
      "inputType": "number",
      "step": "any",
      "validationMessage": "",
      "notes": ""
    },
    "sqlVariant": {
      "minimum": "",
      "maximum": "",
      "maxLength": "",
      "pattern": "",
      "jsonType": "string",
      "component": "",
      "inputType": "",
      "step": "",
      "validationMessage": "",
      "notes": ""
    },
    "ntext": {
      "minimum": "",
      "maximum": "",
      "maxLength": "{{ 1073741823 }}",
      "pattern": "",
      "jsonType": "string",
      "component": "b-input",
      "inputType": "textarea",
      "step": "",
      "validationMessage": "",
      "notes": "The ntext, text, and image data types will be removed in a future version of SQL Server"
    },
    "bit": {
      "minimum": "0",
      "maximum": "1",
      "maxLength": "",
      "pattern": "",
      "jsonType": "boolean",
      "component": "b-checkbox",
      "inputType": "",
      "step": "",
      "validationMessage": "",
      "notes": ""
    },
    "decimal": {
      "minimum": "{{ -1 * ((10 ** (precision - scale)) - 10 ** (-1 * scale) ) }}",
      "maximum": "{{ (10 ** (precision - scale)) - 10 ** (-1 * scale) }}",
      "maxLength": "",
      "pattern": "",
      "jsonType": "number",
      "component": "b-input",
      "inputType": "number",
      "step": "{{ 10 ** (-1 * scale) }}",
      "validationMessage": "",
      "notes": ""
    },
    "numeric": {
      "minimum": "{{ -1 * ((10 ** (precision - scale)) - 10 ** (-1 * scale) ) }}",
      "maximum": "{{ (10 ** (precision - scale)) - 10 ** (-1 * scale) }}",
      "maxLength": "",
      "pattern": "",
      "jsonType": "number",
      "component": "b-input",
      "inputType": "number",
      "step": "{{ 10 ** (-1 * scale) }}",
      "validationMessage": "",
      "notes": ""
    },
    "smallmoney": {
      "minimum": "-214748.3647",
      "maximum": "214748.3647",
      "maxLength": "",
      "pattern": "",
      "jsonType": "number",
      "component": "b-input",
      "inputType": "number",
      "step": "0.0001",
      "validationMessage": "",
      "notes": ""
    },
    "bigint": {
      "minimum": "-9223372036854780000",
      "maximum": "9223372036854780000",
      "maxLength": "",
      "pattern": "",
      "jsonType": "number",
      "component": "b-input",
      "inputType": "number",
      "step": "1",
      "validationMessage": "",
      "notes": ""
    },
    "hierarchyid": {
      "minimum": "",
      "maximum": "",
      "maxLength": "",
      "pattern": "",
      "jsonType": "string",
      "component": "",
      "inputType": "",
      "step": "",
      "validationMessage": "",
      "notes": ""
    },
    "geometry": {
      "minimum": "",
      "maximum": "",
      "maxLength": "",
      "pattern": "",
      "jsonType": "string",
      "component": "",
      "inputType": "",
      "step": "",
      "validationMessage": "",
      "notes": ""
    },
    "geography": {
      "minimum": "",
      "maximum": "",
      "maxLength": "",
      "pattern": "",
      "jsonType": "string",
      "component": "",
      "inputType": "",
      "step": "",
      "validationMessage": "",
      "notes": ""
    },
    "varbinary": {
      "minimum": "",
      "maximum": "",
      "maxLength": "8000",
      "pattern": "",
      "jsonType": "string",
      "component": "",
      "inputType": "",
      "step": "",
      "validationMessage": "",
      "notes": ""
    },
    "varchar": {
      "minimum": "",
      "maximum": "",
      "maxLength": "{{ n }}",
      "pattern": "",
      "jsonType": "string",
      "component": "b-input",
      "inputType": "text",
      "step": "",
      "validationMessage": "",
      "notes": ""
    },
    "binary": {
      "minimum": "",
      "maximum": "",
      "maxLength": "8000",
      "pattern": "",
      "jsonType": "string",
      "component": "",
      "inputType": "",
      "step": "",
      "validationMessage": "",
      "notes": ""
    },
    "char": {
      "minimum": "",
      "maximum": "",
      "maxLength": "{{ n }}",
      "pattern": "",
      "jsonType": "string",
      "component": "b-input",
      "inputType": "text",
      "step": "",
      "validationMessage": "",
      "notes": "How is this different than varchar? char always stores up to n bytes (it pads with blanks). varchar only stores the string you specify. So when is char better? Almost never... Only when you have something like a state abbreviation, since varchar has an extra 2 bytes of overhead."
    },
    "timestamp": {
      "minimum": "",
      "maximum": "",
      "maxLength": "",
      "pattern": "",
      "jsonType": "string",
      "component": "b-timepicker",
      "inputType": "",
      "step": "",
      "validationMessage": "",
      "notes": ""
    },
    "nvarchar": {
      "minimum": "",
      "maximum": "",
      "maxLength": "{{ n / 2 }}",
      "pattern": "",
      "jsonType": "string",
      "component": "b-input",
      "inputType": "text",
      "step": "",
      "validationMessage": "",
      "notes": ""
    },
    "nchar": {
      "minimum": "",
      "maximum": "",
      "maxLength": "{{ n / 2 }}",
      "pattern": "",
      "jsonType": "string",
      "component": "b-input",
      "inputType": "text",
      "step": "",
      "validationMessage": "",
      "notes": ""
    },
    "xml": {
      "minimum": "",
      "maximum": "",
      "maxLength": "",
      "pattern": "",
      "jsonType": "string",
      "component": "",
      "inputType": "",
      "step": "",
      "validationMessage": "",
      "notes": ""
    },
    "sysname": {
      "minimum": "",
      "maximum": "",
      "maxLength": "",
      "pattern": "",
      "jsonType": "string",
      "component": "",
      "inputType": "",
      "step": "",
      "validationMessage": "",
      "notes": ""
    }
  },
  "openapi": {
    "number": {
      "minimum": "",
      "maximum": "",
      "maxLength": "",
      "pattern": "",
      "jsonType": "number",
      "component": "b-input",
      "inputType": "number",
      "step": "any",
      "validationMessage": "",
      "notes": ""
    },
    "number:float": {
      "minimum": "",
      "maximum": "",
      "maxLength": "",
      "pattern": "",
      "jsonType": "number",
      "component": "b-input",
      "inputType": "number",
      "step": "any",
      "validationMessage": "",
      "notes": ""
    },
    "number:double": {
      "minimum": "",
      "maximum": "",
      "maxLength": "",
      "pattern": "",
      "jsonType": "number",
      "component": "b-input",
      "inputType": "number",
      "step": "any",
      "validationMessage": "",
      "notes": ""
    },
    "integer": {
      "minimum": "",
      "maximum": "",
      "maxLength": "",
      "pattern": "",
      "jsonType": "number",
      "component": "b-input",
      "inputType": "number",
      "step": "1",
      "validationMessage": "",
      "notes": ""
    },
    "integer:int32": {
      "minimum": "",
      "maximum": "",
      "maxLength": "",
      "pattern": "",
      "jsonType": "number",
      "component": "b-input",
      "inputType": "number",
      "step": "1",
      "validationMessage": "",
      "notes": ""
    },
    "integer:int64": {
      "minimum": "",
      "maximum": "",
      "maxLength": "",
      "pattern": "",
      "jsonType": "number",
      "component": "b-input",
      "inputType": "number",
      "step": "1",
      "validationMessage": "",
      "notes": ""
    },
    "string": {
      "minimum": "",
      "maximum": "",
      "maxLength": "",
      "pattern": "",
      "jsonType": "string",
      "component": "b-input",
      "inputType": "text",
      "step": "",
      "validationMessage": "",
      "notes": ""
    },
    "string:date": {
      "minimum": "",
      "maximum": "",
      "maxLength": "",
      "pattern": "",
      "jsonType": "string",
      "component": "b-datepicker",
      "inputType": "",
      "step": "",
      "validationMessage": "",
      "notes": ""
    },
    "string:date-time": {
      "minimum": "",
      "maximum": "",
      "maxLength": "",
      "pattern": "",
      "jsonType": "string",
      "component": "b-datetimepicker",
      "inputType": "",
      "step": "",
      "validationMessage": "",
      "notes": ""
    },
    "string:password": {
      "minimum": "",
      "maximum": "",
      "maxLength": "",
      "pattern": "",
      "jsonType": "string",
      "component": "b-input",
      "inputType": "password",
      "step": "",
      "validationMessage": "",
      "notes": ""
    },
    "string:byte": {
      "minimum": "",
      "maximum": "",
      "maxLength": "",
      "pattern": "",
      "jsonType": "string",
      "component": "b-input",
      "inputType": "text",
      "step": "",
      "validationMessage": "",
      "notes": ""
    },
    "string:binary": {
      "minimum": "",
      "maximum": "",
      "maxLength": "",
      "pattern": "",
      "jsonType": "string",
      "component": "b-input",
      "inputType": "text",
      "step": "",
      "validationMessage": "",
      "notes": ""
    },
    "string:email": {
      "minimum": "",
      "maximum": "",
      "maxLength": "",
      "pattern": "",
      "jsonType": "string",
      "component": "b-input",
      "inputType": "email",
      "step": "",
      "validationMessage": "",
      "notes": ""
    },
    "string:uuid": {
      "minimum": "",
      "maximum": "",
      "maxLength": "",
      "pattern": "",
      "jsonType": "string",
      "component": "b-input",
      "inputType": "text",
      "step": "",
      "validationMessage": "",
      "notes": ""
    },
    "string:uri": {
      "minimum": "",
      "maximum": "",
      "maxLength": "",
      "pattern": "",
      "jsonType": "string",
      "component": "b-input",
      "inputType": "text",
      "step": "",
      "validationMessage": "",
      "notes": ""
    },
    "string:hostname": {
      "minimum": "",
      "maximum": "",
      "maxLength": "",
      "pattern": "",
      "jsonType": "string",
      "component": "b-input",
      "inputType": "text",
      "step": "",
      "validationMessage": "",
      "notes": ""
    },
    "string:ipv4": {
      "minimum": "",
      "maximum": "",
      "maxLength": "",
      "pattern": "",
      "jsonType": "string",
      "component": "b-input",
      "inputType": "text",
      "step": "",
      "validationMessage": "",
      "notes": ""
    },
    "string:ipv6": {
      "minimum": "",
      "maximum": "",
      "maxLength": "",
      "pattern": "",
      "jsonType": "string",
      "component": "b-input",
      "inputType": "text",
      "step": "",
      "validationMessage": "",
      "notes": ""
    },
    "boolean": {
      "minimum": "",
      "maximum": "",
      "maxLength": "",
      "pattern": "",
      "jsonType": "boolean",
      "component": "b-checkbox",
      "inputType": "",
      "step": "",
      "validationMessage": "",
      "notes": ""
    },
    "storeTrue": {
      "minimum": "",
      "maximum": "",
      "maxLength": "",
      "pattern": "",
      "jsonType": "boolean",
      "component": "b-checkbox",
      "inputType": "",
      "step": "",
      "validationMessage": "",
      "notes": ""
    },
    "array": {
      "minimum": "",
      "maximum": "",
      "maxLength": "",
      "pattern": "",
      "jsonType": "array",
      "component": "json",
      "inputType": "",
      "step": "",
      "validationMessage": "",
      "notes": ""
    },
    "object": {
      "minimum": "",
      "maximum": "",
      "maxLength": "",
      "pattern": "",
      "jsonType": "object",
      "component": "json",
      "inputType": "",
      "step": "",
      "validationMessage": "",
      "notes": ""
    },
    "<missing>": {
      "minimum": "",
      "maximum": "",
      "maxLength": "",
      "pattern": "",
      "jsonType": "string",
      "component": "b-input",
      "inputType": "text",
      "step": "",
      "validationMessage": "",
      "notes": ""
    }
  },
  "python": {
    "str": {
      "minimum": "",
      "maximum": "",
      "maxLength": "",
      "pattern": "",
      "jsonType": "string",
      "component": "b-input",
      "inputType": "text",
      "step": "",
      "validationMessage": "",
      "notes": ""
    },
    "int": {
      "minimum": "",
      "maximum": "",
      "maxLength": "",
      "pattern": "",
      "jsonType": "number",
      "component": "b-input",
      "inputType": "number",
      "step": "1",
      "validationMessage": "",
      "notes": ""
    },
    "float": {
      "minimum": "",
      "maximum": "",
      "maxLength": "",
      "pattern": "",
      "jsonType": "number",
      "component": "b-input",
      "inputType": "number",
      "step": "",
      "validationMessage": "",
      "notes": ""
    },
    "bool": {
      "minimum": "",
      "maximum": "",
      "maxLength": "",
      "pattern": "",
      "jsonType": "boolean",
      "component": "b-checkbox",
      "inputType": "",
      "step": "",
      "validationMessage": "",
      "notes": ""
    },
    "date": {
      "minimum": "0000-01-01T00:00:00Z",
      "maximum": "9999-12-31T00:00:00Z",
      "maxLength": "",
      "pattern": "",
      "jsonType": "string",
      "component": "b-datepicker",
      "inputType": "",
      "step": "",
      "validationMessage": "",
      "notes": ""
    },
    "datetime": {
      "minimum": "0000-01-01T00:00:00Z",
      "maximum": "9999-12-31T00:00:00Z",
      "maxLength": "",
      "pattern": "",
      "jsonType": "string",
      "component": "b-datetimepicker",
      "inputType": "",
      "step": "",
      "validationMessage": "",
      "notes": ""
    },
    "time": {
      "minimum": "",
      "maximum": "",
      "maxLength": "",
      "pattern": "",
      "jsonType": "string",
      "component": "b-timepicker",
      "inputType": "",
      "step": "",
      "validationMessage": "",
      "notes": ""
    },
    "dict": {
      "minimum": "",
      "maximum": "",
      "maxLength": "",
      "pattern": "",
      "jsonType": "object",
      "component": "json",
      "inputType": "",
      "step": "",
      "validationMessage": "",
      "notes": ""
    },
    "list": {
      "minimum": "",
      "maximum": "",
      "maxLength": "",
      "pattern": "",
      "jsonType": "array",
      "component": "json",
      "inputType": "",
      "step": "",
      "validationMessage": "",
      "notes": ""
    }
  },
  "r": {
    "character": {
      "minimum": "",
      "maximum": "",
      "maxLength": "",
      "pattern": "",
      "jsonType": "string",
      "component": "b-input",
      "inputType": "",
      "step": "",
      "validationMessage": "",
      "notes": ""
    },
    "string": {
      "minimum": "",
      "maximum": "",
      "maxLength": "",
      "pattern": "",
      "jsonType": "string",
      "component": "b-input",
      "inputType": "",
      "step": "",
      "validationMessage": "",
      "notes": ""
    },
    "integer": {
      "minimum": "-2147483648",
      "maximum": "2147483647",
      "maxLength": "",
      "pattern": "",
      "jsonType": "number",
      "component": "b-input",
      "inputType": "number",
      "step": "1",
      "validationMessage": "",
      "notes": ""
    },
    "numeric": {
      "minimum": "",
      "maximum": "",
      "maxLength": "",
      "pattern": "",
      "jsonType": "number",
      "component": "b-input",
      "inputType": "number",
      "step": "",
      "validationMessage": "",
      "notes": ""
    },
    "double": {
      "minimum": "",
      "maximum": "",
      "maxLength": "",
      "pattern": "",
      "jsonType": "number",
      "component": "b-input",
      "inputType": "number",
      "step": "",
      "validationMessage": "",
      "notes": ""
    },
    "logical": {
      "minimum": "",
      "maximum": "",
      "maxLength": "",
      "pattern": "",
      "jsonType": "boolean",
      "component": "b-checkbox",
      "inputType": "",
      "step": "",
      "validationMessage": "",
      "notes": ""
    },
    "storeTrue": {
      "minimum": "",
      "maximum": "",
      "maxLength": "",
      "pattern": "",
      "jsonType": "boolean",
      "component": "b-checkbox",
      "inputType": "",
      "step": "",
      "validationMessage": "",
      "notes": ""
    },
    "storeFalse": {
      "minimum": "",
      "maximum": "",
      "maxLength": "",
      "pattern": "",
      "jsonType": "boolean",
      "component": "b-checkbox",
      "inputType": "",
      "step": "",
      "validationMessage": "",
      "notes": ""
    }
  },
  "postgres": {
    "smallint": {
      "minimum": "-32768",
      "maximum": "32767",
      "maxLength": "",
      "pattern": "",
      "jsonType": "number",
      "component": "b-input",
      "inputType": "number",
      "step": "1",
      "validationMessage": "",
      "notes": ""
    },
    "int2": {
      "minimum": "-32768",
      "maximum": "32767",
      "maxLength": "",
      "pattern": "",
      "jsonType": "number",
      "component": "b-input",
      "inputType": "number",
      "step": "1",
      "validationMessage": "",
      "notes": ""
    },
    "integer": {
      "minimum": "-2147483648",
      "maximum": "2147483647",
      "maxLength": "",
      "pattern": "",
      "jsonType": "number",
      "component": "b-input",
      "inputType": "number",
      "step": "1",
      "validationMessage": "",
      "notes": ""
    },
    "int4": {
      "minimum": "-2147483648",
      "maximum": "2147483647",
      "maxLength": "",
      "pattern": "",
      "jsonType": "number",
      "component": "b-input",
      "inputType": "number",
      "step": "1",
      "validationMessage": "",
      "notes": ""
    },
    "bigint": {
      "minimum": "-9223372036854775808",
      "maximum": "9223372036854775807",
      "maxLength": "",
      "pattern": "",
      "jsonType": "number",
      "component": "b-input",
      "inputType": "number",
      "step": "1",
      "validationMessage": "",
      "notes": ""
    },
    "int8": {
      "minimum": "-9223372036854775808",
      "maximum": "9223372036854775807",
      "maxLength": "",
      "pattern": "",
      "jsonType": "number",
      "component": "b-input",
      "inputType": "number",
      "step": "1",
      "validationMessage": "",
      "notes": ""
    },
    "numeric": {
      "minimum": "{{ -1 * ((10 ** (precision - scale)) - 10 ** (-1 * scale) ) }}",
      "maximum": "{{ (10 ** (precision - scale)) - 10 ** (-1 * scale) }}",
      "maxLength": "",
      "pattern": "",
      "jsonType": "number",
      "component": "b-input",
      "inputType": "number",
      "step": "{{ 10 ** (-1 * scale) }}",
      "validationMessage": "",
      "notes": ""
    },
    "decimal": {
      "minimum": "{{ -1 * ((10 ** (precision - scale)) - 10 ** (-1 * scale) ) }}",
      "maximum": "{{ (10 ** (precision - scale)) - 10 ** (-1 * scale) }}",
      "maxLength": "",
      "pattern": "",
      "jsonType": "number",
      "component": "b-input",
      "inputType": "number",
      "step": "{{ 10 ** (-1 * scale) }}",
      "validationMessage": "",
      "notes": ""
    },
    "real": {
      "minimum": "",
      "maximum": "",
      "maxLength": "",
      "pattern": "",
      "jsonType": "number",
      "component": "b-input",
      "inputType": "number",
      "step": "any",
      "validationMessage": "",
      "notes": ""
    },
    "float4": {
      "minimum": "",
      "maximum": "",
      "maxLength": "",
      "pattern": "",
      "jsonType": "number",
      "component": "b-input",
      "inputType": "number",
      "step": "any",
      "validationMessage": "",
      "notes": ""
    },
    "double precision": {
      "minimum": "",
      "maximum": "",
      "maxLength": "",
      "pattern": "",
      "jsonType": "number",
      "component": "b-input",
      "inputType": "number",
      "step": "any",
      "validationMessage": "",
      "notes": ""
    },
    "float8": {
      "minimum": "",
      "maximum": "",
      "maxLength": "",
      "pattern": "",
      "jsonType": "number",
      "component": "b-input",
      "inputType": "number",
      "step": "any",
      "validationMessage": "",
      "notes": ""
    },
    "smallserial": {
      "minimum": "1",
      "maximum": "32767",
      "maxLength": "",
      "pattern": "",
      "jsonType": "number",
      "component": "b-input",
      "inputType": "number",
      "step": "1",
      "validationMessage": "",
      "notes": ""
    },
    "serial2": {
      "minimum": "1",
      "maximum": "32767",
      "maxLength": "",
      "pattern": "",
      "jsonType": "number",
      "component": "b-input",
      "inputType": "number",
      "step": "1",
      "validationMessage": "",
      "notes": ""
    },
    "serial": {
      "minimum": "1",
      "maximum": "2147483647",
      "maxLength": "",
      "pattern": "",
      "jsonType": "number",
      "component": "b-input",
      "inputType": "number",
      "step": "1",
      "validationMessage": "",
      "notes": ""
    },
    "serial4": {
      "minimum": "1",
      "maximum": "2147483647",
      "maxLength": "",
      "pattern": "",
      "jsonType": "number",
      "component": "b-input",
      "inputType": "number",
      "step": "1",
      "validationMessage": "",
      "notes": ""
    },
    "bigserial": {
      "minimum": "1",
      "maximum": "9223372036854775807",
      "maxLength": "",
      "pattern": "",
      "jsonType": "number",
      "component": "b-input",
      "inputType": "number",
      "step": "1",
      "validationMessage": "",
      "notes": ""
    },
    "serial8": {
      "minimum": "1",
      "maximum": "9223372036854775807",
      "maxLength": "",
      "pattern": "",
      "jsonType": "number",
      "component": "b-input",
      "inputType": "number",
      "step": "1",
      "validationMessage": "",
      "notes": ""
    },
    "money": {
      "minimum": "-922337203685477.5808",
      "maximum": "922337203685477.5808",
      "maxLength": "",
      "pattern": "",
      "jsonType": "number",
      "component": "b-input",
      "inputType": "number",
      "step": "0.0001",
      "validationMessage": "",
      "notes": ""
    },
    "character varying": {
      "minimum": "",
      "maximum": "",
      "maxLength": "{{ n or 1073741824 }}",
      "pattern": "",
      "jsonType": "string",
      "component": "b-input",
      "inputType": "text",
      "step": "",
      "validationMessage": "",
      "notes": ""
    },
    "varchar": {
      "minimum": "",
      "maximum": "",
      "maxLength": "{{ n or 1073741824 }}",
      "pattern": "",
      "jsonType": "string",
      "component": "b-input",
      "inputType": "text",
      "step": "",
      "validationMessage": "",
      "notes": ""
    },
    "character": {
      "minimum": "",
      "maximum": "",
      "maxLength": "{{ n or 1073741824 }}",
      "pattern": "",
      "jsonType": "string",
      "component": "b-input",
      "inputType": "text",
      "step": "",
      "validationMessage": "",
      "notes": ""
    },
    "char": {
      "minimum": "",
      "maximum": "",
      "maxLength": "{{ n or 1073741824 }}",
      "pattern": "",
      "jsonType": "string",
      "component": "b-input",
      "inputType": "text",
      "step": "",
      "validationMessage": "",
      "notes": ""
    },
    "text": {
      "minimum": "",
      "maximum": "",
      "maxLength": "{{ 1073741824 }}",
      "pattern": "",
      "jsonType": "string",
      "component": "b-input",
      "inputType": "textarea",
      "step": "",
      "validationMessage": "",
      "notes": ""
    },
    "bytea": {
      "minimum": "",
      "maximum": "",
      "maxLength": "",
      "pattern": "",
      "jsonType": "string",
      "component": "b-input",
      "inputType": "text",
      "step": "",
      "validationMessage": "",
      "notes": ""
    },
    "timestamp without time zone": {
      "minimum": "0000-01-01T00:00:00Z",
      "maximum": "9999-12-31T00:00:00Z",
      "maxLength": "",
      "pattern": "",
      "jsonType": "string",
      "component": "b-datetimepicker",
      "inputType": "",
      "step": "",
      "validationMessage": "",
      "notes": ""
    },
    "timestamp": {
      "minimum": "0000-01-01T00:00:00Z",
      "maximum": "9999-12-31T00:00:00Z",
      "maxLength": "",
      "pattern": "",
      "jsonType": "string",
      "component": "b-datetimepicker",
      "inputType": "",
      "step": "",
      "validationMessage": "",
      "notes": ""
    },
    "timestamp with time zone": {
      "minimum": "0000-01-01T00:00:00Z",
      "maximum": "9999-12-31T00:00:00Z",
      "maxLength": "",
      "pattern": "",
      "jsonType": "string",
      "component": "b-datetimepicker",
      "inputType": "",
      "step": "",
      "validationMessage": "",
      "notes": ""
    },
    "timestamptz": {
      "minimum": "0000-01-01T00:00:00Z",
      "maximum": "9999-12-31T00:00:00Z",
      "maxLength": "",
      "pattern": "",
      "jsonType": "string",
      "component": "b-datetimepicker",
      "inputType": "",
      "step": "",
      "validationMessage": "",
      "notes": ""
    },
    "date": {
      "minimum": "0000-01-01T00:00:00Z",
      "maximum": "9999-12-31T00:00:00Z",
      "maxLength": "",
      "pattern": "",
      "jsonType": "string",
      "component": "b-datepicker",
      "inputType": "",
      "step": "",
      "validationMessage": "",
      "notes": ""
    },
    "time without time zone": {
      "minimum": "",
      "maximum": "",
      "maxLength": "",
      "pattern": "",
      "jsonType": "string",
      "component": "b-timepicker",
      "inputType": "",
      "step": "",
      "validationMessage": "",
      "notes": ""
    },
    "time": {
      "minimum": "",
      "maximum": "",
      "maxLength": "",
      "pattern": "",
      "jsonType": "string",
      "component": "b-timepicker",
      "inputType": "",
      "step": "",
      "validationMessage": "",
      "notes": ""
    },
    "time with time zone": {
      "minimum": "",
      "maximum": "",
      "maxLength": "",
      "pattern": "",
      "jsonType": "string",
      "component": "b-timepicker",
      "inputType": "",
      "step": "",
      "validationMessage": "",
      "notes": ""
    },
    "timetz": {
      "minimum": "",
      "maximum": "",
      "maxLength": "",
      "pattern": "",
      "jsonType": "string",
      "component": "b-timepicker",
      "inputType": "",
      "step": "",
      "validationMessage": "",
      "notes": ""
    },
    "interval": {
      "minimum": "",
      "maximum": "",
      "maxLength": "",
      "pattern": "",
      "jsonType": "string",
      "component": "b-input",
      "inputType": "text",
      "step": "",
      "validationMessage": "",
      "notes": ""
    },
    "boolean": {
      "minimum": "",
      "maximum": "",
      "maxLength": "",
      "pattern": "",
      "jsonType": "boolean",
      "component": "b-checkbox",
      "inputType": "",
      "step": "",
      "validationMessage": "",
      "notes": ""
    },
    "bool": {
      "minimum": "",
      "maximum": "",
      "maxLength": "",
      "pattern": "",
      "jsonType": "boolean",
      "component": "b-checkbox",
      "inputType": "",
      "step": "",
      "validationMessage": "",
      "notes": ""
    },
    "uuid": {
      "minimum": "",
      "maximum": "",
      "maxLength": "{{ 36 }}",
      "pattern": "^[{]?[0-9a-fA-F]{8}-([0-9a-fA-F]{4}-){3}[0-9a-fA-F]{12}[}]?$",
      "jsonType": "string",
      "component": "b-input",
      "inputType": "text",
      "step": "",
      "validationMessage": "Must be of form: xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx",
      "notes": ""
    },
    "json": {
      "minimum": "",
      "maximum": "",
      "maxLength": "",
      "pattern": "",
      "jsonType": "object",
      "component": "json",
      "inputType": "",
      "step": "",
      "validationMessage": "",
      "notes": ""
    },
    "jsonb": {
      "minimum": "",
      "maximum": "",
      "maxLength": "",
      "pattern": "",
      "jsonType": "object",
      "component": "json",
      "inputType": "",
      "step": "",
      "validationMessage": "",
      "notes": ""
    },
    "point": {
      "minimum": "",
      "maximum": "",
      "maxLength": "",
      "pattern": "",
      "jsonType": "string",
      "component": "b-input",
      "inputType": "text",
      "step": "",
      "validationMessage": "",
      "notes": ""
    },
    "line": {
      "minimum": "",
      "maximum": "",
      "maxLength": "",
      "pattern": "",
      "jsonType": "string",
      "component": "b-input",
      "inputType": "text",
      "step": "",
      "validationMessage": "",
      "notes": ""
    },
    "lseg": {
      "minimum": "",
      "maximum": "",
      "maxLength": "",
      "pattern": "",
      "jsonType": "string",
      "component": "b-input",
      "inputType": "text",
      "step": "",
      "validationMessage": "",
      "notes": ""
    },
    "box": {
      "minimum": "",
      "maximum": "",
      "maxLength": "",
      "pattern": "",
      "jsonType": "string",
      "component": "b-input",
      "inputType": "text",
      "step": "",
      "validationMessage": "",
      "notes": ""
    },
    "path": {
      "minimum": "",
      "maximum": "",
      "maxLength": "",
      "pattern": "",
      "jsonType": "string",
      "component": "b-input",
      "inputType": "text",
      "step": "",
      "validationMessage": "",
      "notes": ""
    },
    "polygon": {
      "minimum": "",
      "maximum": "",
      "maxLength": "",
      "pattern": "",
      "jsonType": "string",
      "component": "b-input",
      "inputType": "text",
      "step": "",
      "validationMessage": "",
      "notes": ""
    },
    "circle": {
      "minimum": "",
      "maximum": "",
      "maxLength": "",
      "pattern": "",
      "jsonType": "string",
      "component": "b-input",
      "inputType": "text",
      "step": "",
      "validationMessage": "",
      "notes": ""
    },
    "inet": {
      "minimum": "",
      "maximum": "",
      "maxLength": "",
      "pattern": "",
      "jsonType": "string",
      "component": "b-input",
      "inputType": "text",
      "step": "",
      "validationMessage": "",
      "notes": ""
    },
    "cidr": {
      "minimum": "",
      "maximum": "",
      "maxLength": "",
      "pattern": "",
      "jsonType": "string",
      "component": "b-input",
      "inputType": "text",
      "step": "",
      "validationMessage": "",
      "notes": ""
    },
    "macaddr": {
      "minimum": "",
      "maximum": "",
      "maxLength": "",
      "pattern": "",
      "jsonType": "string",
      "component": "b-input",
      "inputType": "text",
      "step": "",
      "validationMessage": "",
      "notes": ""
    },
    "macaddr8": {
      "minimum": "",
      "maximum": "",
      "maxLength": "",
      "pattern": "",
      "jsonType": "string",
      "component": "b-input",
      "inputType": "text",
      "step": "",
      "validationMessage": "",
      "notes": ""
    },
    "bit": {
      "minimum": "",
      "maximum": "",
      "maxLength": "{{ n or 1073741824 }}",
      "pattern": "",
      "jsonType": "string",
      "component": "b-input",
      "inputType": "text",
      "step": "",
      "validationMessage": "",
      "notes": ""
    },
    "bit varying": {
      "minimum": "",
      "maximum": "",
      "maxLength": "{{ n or 1073741824 }}",
      "pattern": "",
      "jsonType": "string",
      "component": "b-input",
      "inputType": "text",
      "step": "",
      "validationMessage": "",
      "notes": " "
    }
  }
} as const;

export type TypeSystemMap = typeof typeSystemMap;
